import * as _ from 'lodash';
import { featureFlag } from 'src/environments/environment';
import { LoaUserTypeEnum } from './loa.model';

export function emailIsValid(email: any): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function phoneIsValid(phoneNumber: any): boolean {
  const pattern = /^(\d{3}-\d{3}-\d{4}|\d{10})$/;
  return phoneNumber != null && pattern.test(phoneNumber);
}

export function checkMail(levels: any): boolean {
  let result = true;
  _.forEach(levels, (level) => {
    if (level.user_type === 'user') {
      result = true;
    } else {
      _.forEach(level.members, (member) => {
        if (
          member.no_person &&
          !member.person?.name &&
          !member.person?.job_position &&
          !member.person?.phone_number
        ) {
          result = true;
        } else if (
          member.person &&
          !Number.isInteger(member.person) &&
          !emailIsValid(member.person?.email)
        ) {
          result = false;
        }
      });
    }
  });
  return result;
}

export function checkPhoneNumber(levels: any): boolean {
  let result = true;
  _.forEach(levels, (level) => {
    if (level.user_type === 'user') {
      result = true;
    } else {
      if (featureFlag.ddoc) {
        _.forEach(level.members, (member) => {
          if (
            !member.ddoc_use_26 &&
            !member.ddoc_use_28 &&
            (member.person?.phone_number === '' ||
              member.person?.phone_number === null)
          ) {
            return;
          }
          if (
            member.person &&
            !Number.isInteger(member.person) &&
            !phoneIsValid(member.person?.phone_number)
          ) {
            result = false;
          }
        });
      }
    }
  });
  return result;
}

export function hasEmptyProperty(obj: any) {
  for (const key in obj) {
    // we already have function to check phone number
    if (['phone_number', 'id', 'job_position'].includes(key)) {
      continue;
    }

    if (obj[key] === null || obj[key] === '') return true;
  }
  return false;
}

export function checkEmptyApprover(
  levels: any,
  allowNoPerson = false,
  excludeLvlFn?: (level: any) => boolean,
) {
  const someEmpty = levels?.some((level: any) => {
    if (excludeLvlFn && excludeLvlFn(level)) {
      return false;
    }
    let members = level.members;
    if (allowNoPerson) {
      members = members.filter((member: any) => !member.no_person);
    }

    return members.some(
      (member: any) =>
        !member.person || hasEmptyProperty(member.person),
    );
  });
  if (someEmpty) {
    return false;
  }
  return true;
}
